import VirtualPortalFooter from './VirtualPortalFooter'

export default VirtualPortalFooter